import './h5sdk';
import Queue from './queue';

/**
 * 直播间websocket及taf接口封装
 */

class H5SdkApi {
    constructor() {
        this.inited = false;
        this._callbacks = new Queue();
    }
    

    /**
     * 初始化ws
     * @param {object} env    直播间信息{topsid: '频道号', subsid:'子频道号' , presenterUid: '主播uid'}
     * @param {function} callback   初始化成功之后的回调
     */
    initWS(env, callback) {
        if (!window.H5Sdk) {
            console.error('sdk加载失败');
            return;
        }
        if (!env.topsid && !env.subsid) {
            console.error('频道号或子频道号不能为空');
            return;
        }

        this._h5sdk = new window.H5Sdk(env);
        this._h5sdk.addListener('WEBSOCKET_INITED', () =>{
            this.inited = true;
            callback && callback();
            this._callbacks.run();
        });

	    this._h5sdk.addListener('SET_GUID', (value)=> {
		    window.sGuid = value;
	    })
    }
    /**
     * 执行消息
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    _sendTaf(type, req = {}, callback) {
        if (typeof req === 'function') {
            [req, callback] = [{}, req]
        }

        if( this.inited ){//初始化完成
            this._h5sdk.sendTaf(type, req, (data) => {
                callback && callback(data);
            });
        }else{//初始化未完成
            this._callbacks.add( () => {
                this._h5sdk.sendTaf(type, req, (data) => {
                    callback && callback(data);
                });
            });
        }
        
    }

	/**
	 *
	 * @param data
	 */
	setUserId(data) {
		this._h5sdk.setUserId(data);
	}

    /**
     * 获取直播间信息
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    getLivingInfo(req , callback) {
        this._sendTaf('getLivingInfo', req, callback);
    }

    /**
     * 获取订阅状态
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    getSubscribeStatus(req, callback) {
        this._sendTaf('getSubscribeStatus', req, callback);
    }
    /**
     * 订阅
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    subscribe(req , callback) {
        this._sendTaf('subscribe', req, callback);
    }
    /**
     * 订阅
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    unsubscribe(req , callback) {
        this._sendTaf('unsubscribe', req, callback);
    }
    /**
     * 发送聊天消息
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    sendMessage(req , callback) {
        this._sendTaf('sendMessage', req, callback);
    }
    /**
     * 获取礼物列表
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    getPropsList(req , callback) {
        this._sendTaf('getPropsList', req, callback);
    }
    /**
     * 获取ws状态
     */
    getWSConnectState() {
        console.log(this._h5sdk)
        return this._h5sdk.getWSConnectState();
    }

    /**
     * 发送礼物
     * @param req {Object} 礼物发送配置
     * @param cb {Function}发送成功回调
     */
    sendCardPackage(req, cb){
        let options = Object.assign({
            iFromType: 11,
            iTemplateType: 5,
            iItemCountByGroup: 0
        }, req);
        this._sendTaf('sendCardPackageItem', options, cb);
    }

    /**
     * 获取背包状态
     * @param {object} req 请求参数
     * @param {function} callback 回调
     */
    queryCardPackage(req , callback){
        this._sendTaf('queryCardPackage', req, callback);
    }

    /**
     * 注册监听消息事件
     * @param {string} msgTypeId 消息类型id
     * @param {function} callback 回调
     */
    _registerTafListener(msgTypeId, callback) {
        if( this.inited ) {//初始化完成
            this._h5sdk.addTafListener(msgTypeId, function (data) {
                callback && callback(data);
            });
        }else{
            this._callbacks.add(() => {
                this._h5sdk.addTafListener(msgTypeId,(data) =>{
                    callback && callback(data);
                });
            });
        }

    }

    /**
     * 订阅消息通知
     * @param {function} callback 回调
     */
    addSubscribeMsgListener(callback) {
        this._registerTafListener('3104', callback);
    }

    /**
     * 公屏消息通知
     * @param {function} callback 回调
     */
    addChatMsgListener(callback) {
        this._registerTafListener('1400', callback);
    }

    /**
     * 贵族入场消息
     * @param {function} callback 回调
     */
    vipEnterBanner(callback) {
        this._registerTafListener('6110', callback);
    }

    /**
     * 礼物消息通知
     * @param {function} callback 回调
     */
    addGiftMsgListener(callback) {
        this._registerTafListener('6501', callback);
    }

    /**
     * 人气变动消息通知
     * @param {function} callback 回调
     */
    addAttendeeChangeListener(callback) {
        this._registerTafListener('8006', callback);
    }

    /**
     * 停播通知
     * @param {function} callback 回调
     */
    addStopLiveListener(callback) {
        this._registerTafListener('8001', callback);
    }

    /**
     * 重新打开ws
     */
    openWs(){
        if( this._h5sdk){
            this._h5sdk.openWs();
        }
    }

    /**
     * 关闭ws
     */
    closeWs(){
        if( this._h5sdk){
            this._h5sdk.closeWs();
        }
    }
}


export default new H5SdkApi();


// WEBPACK FOOTER //
// ./src/common/js/h5sdkApi.js